
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';

import {classroomApi} from '@/api';
import listRequest from '../../../js/listRequest.js';
import formHelper from '../../../js/classroom/classroom.helper';

@Component
export default class classroom extends Vue {
    //===================================data区域begin
    columns: any = formHelper.columns;
    pager: any = {
        default: {
            pagesize: listRequest.pagesize,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };
    form: any = formHelper.copyNewForm(formHelper.form);
    formRules: any = formHelper.formRules;
    pageData: any = {
        typeList: []
    };
    query: any = {
        content: ''
    };
    //===================================data区域end

    //===================================computed区域begin
    //===================================computed区域end

    //===================================methods区域begin
    //删除教室
    handleInDelete(fdId: any) {
        let me = this;
        this.$confirm({
            title: '提示',
            content: '确定删除该教室？',
            centered: true,
            onOk() {
                me.onDoDelete(fdId);
            },
            onCancel() {}
        });
    }
    onDoDelete(fdId: any) {
        let me = this;
        classroomApi.deleteRecord({
            context: this,
            urlParamObj: {
                _id: fdId
            },
            success(data: any, parameters: any) {
                me.$message.success('操作成功');
                me.getList();
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }

    // 新建页面
    jumpAdd(flag: any, fdId?: any) {
        let me = this;
        let classId = fdId;
        let path = '/school/classroom/classroom_edit';
        me.$router.push({
            path: path,
            query: {
                type: flag,
                classId: classId
            }
        });
    }

    //模糊搜索
    onDoQueryList() {
        this.pager.default.pagenum = 1;
        this.pager.default.rows = [];
        this.getList();
    }

    //获取教室列表
    getList() {
        let state = this.$app.getState();
        let schoolId = state.schoolId;
        let me = this;
        let urlQueryParmas = {
            address: me.query.content,
            schoolId: schoolId
        };
        classroomApi.getList({
            context: this,
            pager: me.pager.default,
            urlQueryParmas: urlQueryParmas,
            initCodeRules: {
                //配置这个会自动解析
                //initCodeRules中  列表数据项的属名名称，对应的codelist数据
                //	配置后会自动在列表数据项目挂载XXDesc（对应的中文，多个用逗号分隔）,XXCodeItems（对应的编码数组）
                type: me.pageData.typeList
            }
            // success(data: any, parameters: any) {
            // 	me.form = formHelper.dbToForm(data.data, me.form);
            // 	console.log(me.form)
            // },
            // error(error: any, message: string, parameters: any) {
            // 	me.$message.error(message);
            // },
        });
    }

    paginationChange(page: number, pageSize: number) {
        this.pager.default.pagenum = page;
        this.getList();
    }
    //===================================methods区域end

    created() {
        let me = this;
        this.$pageHelper.loadCodes({
            context: me,
            multipleCodeStr: 'classroom_type',
            success(codesJson: any) {
                me.$pageHelper.initPageDataItem(me.pageData.typeList, codesJson, 'classroom_type'); //教室类型
                me.getList();
            }
        });
        me.getList();
    }
}
